<div class="spotlight-overlay" *ngIf="isVisible">
  <!-- Backdrop with cutout -->
  <div class="backdrop"
       [style.clip-path]="backdropClipPath"
       (click)="onBackdropClick()">
  </div>

  <!-- Highlight ring around element -->
  <div class="highlight-ring"
       [style.top]="highlightStyle.top"
       [style.left]="highlightStyle.left"
       [style.width]="highlightStyle.width"
       [style.height]="highlightStyle.height">
  </div>

  <!-- Tooltip with message and actions -->
  <ai-step-tooltip
    *ngIf="config"
    [message]="config.message"
    [eyebrow]="config.eyebrow"
    [title]="config.title"
    [position]="config.tooltipPosition"
    [style]="tooltipStyle"
    [showNext]="config.showNext"
    [showSkip]="config.showSkip"
    [canGoBack]="config.canGoBack"
    [mediaUrl]="config.mediaUrl"
    (next)="onNext()"
    (skip)="onSkip()"
    (back)="onBack()">
  </ai-step-tooltip>
</div>
